import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, confirm } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import Textarea from 'react-textarea-autosize';

const PolicyEdit = observer(class PolicyEdit extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.toggleDateRange = this.toggleDateRange.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleRule = this.handleRule.bind(this);
    this.addRule = this.addRule.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { policy } = this.props;

    this.state = {
      dateRange: false,
      originalPolicy: {...policy}
    }

    if(
      policy.effectiveDate !== '2000-01-01T05:00:00.000Z' ||
      policy.expirationDate !== '2070-01-01T05:00:00.000Z'
    ) {
      this.setState({
        dateRange: true
      });
    }
  }

  handleInput() {
    const { policy } = this.props;

    policy.title = this.title.value;
    policy.notes = this.notes.value
  }

  handleDate(date, name) {
    const { policy } = this.props;

    policy[name] = moment(date).toISOString();
  }

  togglePolicy(e) {
    const _this = this;
    const { policy } = this.props;
    const { originalPolicy } = this.state;

    if(e.target.checked) {
      policy.status = 'enabled';
    } else {
      policy.status = 'disabled';
    }

    // If this is a pre-existing policy, save it
    originalPolicy.status = policy.status;

    this.setState({
      originalPolicy
    }, function(){
      if(policy.rules[0].sid) {
        this.handleSubmit(null, this.state.originalPolicy);
      }
    });
  }

  toggleDateRange() {
    const { policy } = this.props;
    const _this = this;

    this.setState({
      dateRange: !this.state.dateRange
    }, function(){
      if(!_this.state.dateRange) {
        policy.effectiveDate = '2000-01-01T05:00:00.000Z';
        policy.expirationDate= '2070-01-01T05:00:00.000Z';
      }
    });
  }

  convertDuration(duration, unit) {
    let days = Math.floor(duration / 1440);

    if(unit === 'day') {
      return days;
    } else if(unit === 'hr') {
      let durationMinusDays = duration - (1440 * days);
      return Math.floor(durationMinusDays / 60);
    } else {
      return duration % 60;
    }
  }

  handleRule(i) {
    const { policy } = this.props;

    // Set the rule time
    const day = parseInt(this[`durationDay-${i}`].value, 10);
    const hr = parseInt(this[`durationHr-${i}`].value, 10);
    const min = parseInt(this[`durationMin-${i}`].value, 10);
    const value = (day * 1440) + (hr * 60) + min;

    policy.rules[i].minutesPrior = value;

    // Set the rule percentage
    policy.rules[i].penaltyPercentage = parseInt(this[`percentage-${i}`].value, 10);
  }

  addRule() {
    const { policy } = this.props;

    const newRule = {
      minutesPrior: 0,
      penaltyPercentage: 0
    }

    policy.rules.push(newRule);
  }

  removeRule(i) {
    const { policy } = this.props;
    const { rules } = policy;

    rules.splice(i, 1);
  }

  handleSubmit(e, providedPolicy) {
    const { policy, policySid } = this.props;
    const { PolicyStore } = this.props.store;

    // Determine whether we’re editing or creating
    if(policy.rules[0].sid) {
      // Editing
      if(!policy.policyVersionSid) {
        policy.policyVersionSid = policy.sid;
        policy.sid = policySid;
      }

      if(providedPolicy && !providedPolicy.policyVersionSid) {
        providedPolicy.policyVersionSid = providedPolicy.sid;
        providedPolicy.sid = policySid;
      }

      PolicyStore.updateCancellationPolicy(providedPolicy || policy);
    } else {
      // Creating
      PolicyStore.createCancellationPolicy(policy);
    }
  }

  handleDelete() {
    const { policySid, translation } = this.props;
    const { PolicyStore } = this.props.store;

    const msg = translation.delete_confirm;

    confirm(msg, () => PolicyStore.deleteCancellationPolicy(policySid));
  }

  render() {
    const { policy, translation } = this.props;

    return(
      <form
        className={`
          panel panel--medium panel--editable
          ${policy.status.toLowerCase() !== 'enabled' ? 'disabled' : ''}
        `}
        onSubmit={(e) => checkValidity(e, this.handleSubmit)}
        noValidate
      >
        <div className="panel__header">
          <h3
            className="panel__title"
          >
            {policy.status.toLowerCase() === 'enabled' &&
              <label htmlFor={`title-${policy.sid}`}>
                <icons.iconEdit />
                <span className="meta">{translation.title}</span>
              </label>
            }

            <input
              id={`title-${policy.sid}`}
              onChange={this.handleInput}
              ref={(input) => this.title = input}
              defaultValue={policy.title}
              required
              aria-required="true"
              disabled={policy.status.toLowerCase() === 'disabled'}
            />
          </h3>


          <label
            htmlFor={`enabled-${policy.sid}`}
            className="switch-label--alt"
          >
            {
              policy.status.toLowerCase() === 'enabled' ?
              translation.enabled :
              translation.disabled
            }
          </label>

          <input
            type="checkbox"
            id={`enabled-${policy.sid}`}
            className="switch-input"
            checked={policy.status.toLowerCase() === 'enabled'}
            onChange={(e) => this.togglePolicy(e)}
          />

          <label
            htmlFor={`enabled-${policy.sid}`}
            className="switch-label"
          >
            <span className="meta">
              {
                policy.status.toLowerCase() === 'enabled' ?
                translation.enabled :
                translation.disabled
              }
            </span>
          </label>
        </div>

        <fieldset className="panel__fields">
          <ul className="fields">
            <li>
              <strong className="label-faux">{translation.rules}</strong>

              {policy.rules.map(
                (rule, i) =>
                <ul className="form-inline text-block" key={i}>
                  <li className="time-select time-select--alt" key={i}>
                    <label
                      className="lbl-required"
                      htmlFor={`days-${policy.sid}-${i}`}
                    >
                      {translation.period}
                    </label>

                    <input
                      className="inp-hidden"
                      type="text"
                      value={rule.minutesPrior || ''}
                      ref={(input) => this[`duration-${i}`] = input}
                      onChange={() => {return null}}
                      required
                      aria-required="true"
                    />

                    <label className="select">
                      <select
                        id={`days-${policy.sid}-${i}`}
                        value={this.convertDuration(rule.minutesPrior, 'day')}
                        onChange={() => this.handleRule(i)}
                        ref={(input) => this[`durationDay-${i}`] = input}
                      >
                        <option value="0">0 {translation.days}</option>
                        <option value="1">1 {translation.day}</option>
                        <option value="2">2 {translation.days}</option>
                        <option value="3">3 {translation.days}</option>
                        <option value="4">4 {translation.days}</option>
                        <option value="5">5 {translation.days}</option>
                        <option value="6">6 {translation.days}</option>
                        <option value="7">7 {translation.days}</option>
                      </select>
                    </label>

                    <label className="select">
                      <select
                        id={`hours-${policy.sid}-${i}`}
                        value={this.convertDuration(rule.minutesPrior, 'hr')}
                        onChange={() => this.handleRule(i)}
                        ref={(input) => this[`durationHr-${i}`] = input}
                      >
                        <option value="0">0 {translation.hours}</option>
                        <option value="1">1 {translation.hour}</option>
                        <option value="2">2 {translation.hours}</option>
                        <option value="3">3 {translation.hours}</option>
                        <option value="4">4 {translation.hours}</option>
                        <option value="5">5 {translation.hours}</option>
                        <option value="6">6 {translation.hours}</option>
                        <option value="7">7 {translation.hours}</option>
                        <option value="8">8 {translation.hours}</option>
                        <option value="9">9 {translation.hours}</option>
                        <option value="10">10 {translation.hours}</option>
                        <option value="11">11 {translation.hours}</option>
                        <option value="12">12 {translation.hours}</option>
                        <option value="13">13 {translation.hours}</option>
                        <option value="14">14 {translation.hours}</option>
                        <option value="15">15 {translation.hours}</option>
                        <option value="16">16 {translation.hours}</option>
                        <option value="17">17 {translation.hours}</option>
                        <option value="18">18 {translation.hours}</option>
                        <option value="19">19 {translation.hours}</option>
                        <option value="20">21 {translation.hours}</option>
                        <option value="21">20 {translation.hours}</option>
                        <option value="22">22 {translation.hours}</option>
                        <option value="23">23 {translation.hours}</option>
                      </select>
                    </label>

                    <label className="select">
                      <select
                        id={`minutes-${policy.sid}-${i}`}
                        value={this.convertDuration(rule.minutesPrior, 'min')}
                        onChange={() => this.handleRule(i)}
                        ref={(input) => this[`durationMin-${i}`] = input}
                      >
                        <option value="0">0 {translation.minutes}</option>
                        <option value="5">5 {translation.minutes}</option>
                        <option value="10">10 {translation.minutes}</option>
                        <option value="15">15 {translation.minutes}</option>
                        <option value="20">20 {translation.minutes}</option>
                        <option value="25">25 {translation.minutes}</option>
                        <option value="30">30 {translation.minutes}</option>
                        <option value="35">35 {translation.minutes}</option>
                        <option value="40">40 {translation.minutes}</option>
                        <option value="45">45 {translation.minutes}</option>
                        <option value="50">50 {translation.minutes}</option>
                        <option value="55">55 {translation.minutes}</option>
                      </select>
                    </label>
                  </li>
                  <li>
                    <label
                      className="lbl-required"
                      htmlFor={`penalty-${policy.sid}-${i}`}
                    >
                      {translation.penalty}
                    </label>

                    <span className="decorated-input decorated-input--after">
                      <input
                        type="number"
                        min="1"
                        max="100"
                        step="1"
                        value={rule.penaltyPercentage}
                        onChange={() => this.handleRule(i)}
                        ref={(input) => this[`percentage-${i}`] = input}
                        required
                        aria-required="true"
                      />

                      <i>%</i>
                    </span>
                  </li>
                  <li className="btns">
                    <button
                      className="btn--add"
                      onClick={this.addRule}
                    >
                      <icons.iconPlus /> <span>{translation.add_row}</span>
                    </button>

                    {policy.rules.length > 1 &&
                      <button
                        className="btn--remove"
                        onClick={() => this.removeRule(i)}
                      >
                        <icons.iconMinus /> <span>{translation.remove_row}</span>
                      </button>
                    }
                  </li>
                </ul>
              )}
            </li>
            <li>
              <label
                htmlFor={`date-range-${policy.sid}`}
              >
                {translation.date}
              </label>

              <input
                type="checkbox"
                id={`date-range-${policy.sid}`}
                className="switch-input"
                defaultChecked={
                  policy.effectiveDate !== '2000-01-01T05:00:00.000Z' ||
                  policy.expirationDate !== '2070-01-01T05:00:00.000Z'
                }
                onChange={this.toggleDateRange}
              />

              <label
                htmlFor={`date-range-${policy.sid}`}
                className="switch-label"
              >
                <span className="meta">
                  {translation.date}
                </span>
              </label>
            </li>
            {this.state.dateRange &&
              <li className="field--half">
                <label
                  htmlFor={`start-date-${policy.sid}`}
                  className="lbl-required"
                >
                  {translation.start_date}
                </label>

                <DatePicker
                  id={`start-date-${policy.sid}`}
                  selected={policy.effectiveDate ? moment(policy.effectiveDate).tz(moment.tz.guess()) : null}
                  maxDate={policy.expirationDate}
                  onChange={(date, e) => this.handleDate(date, 'effectiveDate', e)}
                  placeholderText={translation.date_helper}
                  required
                  aria-required="true"
                  autoComplete="off"
                />
              </li>
            }
            {this.state.dateRange &&
              <li className="field--half">
                <label
                  htmlFor={`end-date-${policy.sid}`}
                  className="lbl-required"
                >
                  {translation.end_date}
                </label>

                <DatePicker
                  id={`end-date-${policy.sid}`}
                  selected={policy.expirationDate ? moment(policy.expirationDate).tz(moment.tz.guess()) : null}
                  maxDate={policy.expirationDate}
                  onChange={(date, e) => this.handleDate(date, 'expirationDate', e)}
                  placeholderText={translation.date_helper}
                  required
                  aria-required="true"
                  autoComplete="off"
                />
              </li>
            }
            <li>
              <label htmlFor={`notes-${policy.sid}`}>
                {translation.notes}
              </label>

              <Textarea
                id={`notes-${policy.sid}`}
                className="textarea-grow"
                ref={(input) => this.notes = input}
                onChange={this.handleInput}
                defaultValue={policy.notes}
              ></Textarea>
            </li>
          </ul>
        </fieldset>

        <div className="panel__actions actions">
          <button
            className="btn--link negative"
            type="button" onClick={this.handleDelete}
          >
            {translation.delete_button}
          </button>

          <button
            className="actions__btn actions__btn--primary"
            type="submit"
          >
            {translation.button}
          </button>
        </div>
      </form>
    )
  }
})

export default translate('PolicyEdit')(PolicyEdit);



// WEBPACK FOOTER //
// ./src/app/components/Policies/PolicyEdit.js